import { ReactElement } from 'react';
import { LambdaPutFunctionScalingConfigRequest } from '@localstack/types';
import { AwsClientOverrides, getSchema } from '@localstack/services';
import { LambdaFunctionScalingConfig } from '@localstack/types/src/resource';

import { MagicForm } from '../../magic/MagicForm';

export type LambdaFunctionScalingConfigFormProps = {
  functionNameWithoutVersion: Optional<string>;
  functionVersion: Optional<string>;
  scalingConfig?: LambdaFunctionScalingConfig;
  loading?: boolean;
  formId: string;
  clientOverrides?: AwsClientOverrides;
  onSubmit: (data: LambdaPutFunctionScalingConfigRequest) => unknown;
};

export const LambdaFunctionScalingConfigForm = ({
  functionNameWithoutVersion,
  functionVersion,
  scalingConfig,
  loading,
  formId,
  onSubmit,
}: LambdaFunctionScalingConfigFormProps): ReactElement => (
  <>
    <MagicForm
      data={{
        FunctionName: functionNameWithoutVersion,
        Qualifier: functionVersion,
        FunctionScalingConfig: scalingConfig,
      }}
      fieldConditions={{
        FunctionName: false,
        Qualifier: false,
      }}
      schema={getSchema('Lambda')}
      formId={formId}
      entry="PutFunctionScalingConfigRequest"
      loading={loading}
      onSubmit={(data: LambdaPutFunctionScalingConfigRequest) => onSubmit(data)}
    />
  </>
);
